'use client';
import dynamic from 'next/dynamic';

import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import PHPwebServices from '@/components/technologies/phpweb-services';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Develop Secure, Scalable and High-Performing Web Application with The Leading PHP Development Company"
                alt="Php Development"
                title="Php Development"
                width={1090}
                height={604}
                path={'php-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                PHP<div>Development Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="PHP Development" />

            <ContetVideoSection title="Build Scalable and Dynamic Web Applications with Most Popular Web Development Language">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Being one of the best server side scripting language and part of LAMP, PHP is widely accepted and used to
                        create most impulsive and interactive web applications. Supporting a wide range of database including
                        MySQL along with cross-browser compatibility, PHP is used to develop most innovative and dynamic web
                        applications for multiple verticals. When it comes to security and scalability, PHP is unbeatable.
                    </p>
                    <p className="fw-400 text-secondary fs-md  mb-0">
                        Want to Build Rich-Featured and Custom PHP Application Development with Us?
                    </p>
                </>
            </ContetVideoSection>
            <PHPwebServices></PHPwebServices>
            <HireProcess
                bg="bg-php"
                pageTitle="Hire PHP Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using PHP."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For PHP Development? " />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best PHP Developers"
                desc="Select from different engagement models to hire PHP Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
